import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';

export const initialValues = {
  person: '',
  email: '',
  password: '',
  type: '',
  account: '',
  access: '',
  SalesforceManagement_BusinessUserStatuses: 'NEW',
  isAdmin: false,
};

export const drawerSections = (
  businessUserId: string,
  defaultValues: Record<string, any> = initialValues,
  lookups: Record<string, Record<string, string>>
): IDynamicFormWidgetSection[] => [
  {
    inputs: {
      person: {
        name: 'person',
        title: 'Person',
        type: FormFieldType.autocomplete,
        placeholder: 'Type to search for Person',
        value: defaultValues.person,
        disabled: false,
        required: !businessUserId,
        hidden: !!businessUserId,
      },
      email: {
        name: 'email',
        title: 'Email',
        placeholder: 'Email',
        type: FormFieldType.text,
        value: defaultValues.email,
        disabled: true,
        hidden: !!businessUserId,
      },
      password: {
        name: 'password',
        title: 'Password',
        placeholder: 'Password',
        type: FormFieldType.password,
        value: defaultValues.password,
        hidden: !!businessUserId,
        strongValidation: true,
      },
      type: {
        name: 'type',
        title: 'Type',
        type: FormFieldType.select,
        placeholder: 'Type',
        value: defaultValues.type,
        required: true,
        selectOptions: lookups['type'],
      },
      account: {
        name: 'account',
        title: 'Account',
        placeholder: 'Account',
        type: FormFieldType.text,
        value: defaultValues.account,
      },
      access: {
        name: 'access',
        title: 'Access',
        type: FormFieldType.select,
        placeholder: 'Access',
        value: defaultValues.access,
        required: true,
        selectOptions: lookups['access'],
      },
      SalesforceManagement_BusinessUserStatuses: {
        name: 'SalesforceManagement_BusinessUserStatuses',
        title: 'Status',
        type: FormFieldType.select,
        value: defaultValues.SalesforceManagement_BusinessUserStatuses || '',
        required: !businessUserId,
        disabled: true,
        hidden: !!businessUserId,
        selectOptions: lookups['SalesforceManagement_BusinessUserStatuses'],
      },
      isAdmin: {
        name: 'isAdmin',
        title: 'Admin Role',
        type: FormFieldType.switch,
        value: defaultValues.isAdmin === 'Yes' ? true : false,
        conditionalDisable: (values) => {
          return values.access === 'POS';
        },
      },
    },
  },
];
